module.exports = __webpack_public_path__ + "img/logo-mini.59b8bce6.png";